import { render, staticRenderFns } from "./Terminados.vue?vue&type=template&id=37cfa947"
import script from "./Terminados.vue?vue&type=script&lang=js"
export * from "./Terminados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports